function normalizeInformativeLabel(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/\u2019/g, "'")
    .replace(/\s+/g, ' ');
}

const DEFAULT_INFORMATIVE_LABEL_CLASSES = 'bg-primary/12 text-primary border-primary/30';

const INFORMATIVE_LABEL_CLASSES: Record<string, string> = {
  'thought of the day': 'bg-amber-500/15 text-amber-900 border-amber-500/35',
  'health tip': 'bg-green-500/15 text-green-900 border-green-500/35',
  'do you know?': 'bg-blue-500/15 text-blue-900 border-blue-500/35',
  "today's wisdom": 'bg-violet-500/15 text-violet-900 border-violet-500/35',
  motivation: 'bg-red-500/15 text-red-900 border-red-500/35',
  'tip of the day': 'bg-cyan-500/15 text-cyan-900 border-cyan-500/35',
  'quick reminder': 'bg-orange-500/15 text-orange-900 border-orange-500/35',
};

export function getInformativePostLabelClasses(label: string): string {
  const key = normalizeInformativeLabel(label);
  return INFORMATIVE_LABEL_CLASSES[key] ?? DEFAULT_INFORMATIVE_LABEL_CLASSES;
}
